export default "__VITE_ASSET__CC38yi81__"